<template>
  <div>
    <table>
      <tr>
        <td>Formulare zum Versand</td>
        <td>
          <SogDataLabel
            :value="details?.getNumberValue(PersonDetailsId.ExportBlankCountToSend) ?? 0"
          />
        </td>
      </tr>
      <tr>
        <td>Mindest Bestand</td>
        <td>
          <SogDataLabel
            :value="details?.getNumberValue(PersonDetailsId.ExportBlankMinimumCount) ?? 0"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import PersonDetails from "@/shared/model/personDetails";
import PersonDetailsId from "@/shared/model/personDetailsId";
import Person from "@/shared/model/person";

interface Props {
  person?: Person,
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
      person: undefined,
      details: undefined
    }
)


</script>

<style scoped>
td {
  padding-right: 10px;
}

</style>